export class SuscribeRadio{
    id?:string;
    name:string;
    email:string;
    lastname:string;
    dateofBirth:Date;
    categoris:{id:string, name:string}[];
    createdAt:any;
    deleted:boolean;
}